<template>
	<div class="photo-app">
		<div class="photo">
			<div class="user-title">
				<span>修改头像</span>
			</div>
			<dl>
				<dt>当前头像{{userInfo}}</dt>
				<dd>
					如果您还没有设置自己的头像，系统会显示为默认头像，您需要自己上传一张新图片作为自己的个人头像。
				</dd>
				<dd>请点击图片上传修改头像。</dd>
			</dl>
			<div class="unload-photo">
				<!-- <form action enctype="multipart/form-data">
					<p>
						<img v-if="imageUrl" :src="imageUrl" alt />
						<i v-else class="el-icon-plus"></i>
					</p>
					<input type="file" id="file" accept="image/png, image/jpeg, image/gif, image/jpg"
						@change="changepic" title="请选择图片" />
				</form> -->
				<!-- <el-upload class="avatar-uploader" action="https://jiekou.sz517.com/tiku/public/imageUpload"
					ref="upload" :show-file-list="false" :on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload" :headers="importHeaders">
					<img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 180px;height: 180px;">
					<img v-else-if="imageUrl" :src="imageUrl" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload> -->
				<el-upload class="avatar-uploader" action="https://jiekou.sz517.com/tiku/public/imageUpload"
					ref="upload" :show-file-list="false" :on-success="handleAvatarSuccess"
					:auto-upload="false"
					
					:before-upload="beforeAvatarUpload" :headers="importHeaders">
					<img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 180px;height: 180px;">
					<!-- <img v-else-if="imageUrl" :src="imageUrl" class="avatar"> -->
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>

			<el-button type="primary" style="width: 200px; margin-top: 10px" @click="sureUpload">确认上传</el-button>
		</div>
	</div>
</template>

<script>
	import api from '@/utils/api.js'
	export default {
		name: "photo-app",
		data() {
			return {
				imageUrl: "",
				userInfo: "",
				fd: "",
				progressPercent: "",
				progressFlag: "",
				importHeaders: {},
			};
		},
		methods: {
			async sureUpload() {
				this.$api.updateImg({img:this.imageUrl}).then(res =>{
					this.$router.go(0)
					//console.log(res)
				})
			},
			beforeAvatarUpload(file) {
				console.log(file,'wwww')
				const isJPG = file.type
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			handleAvatarSuccess(res, file) {
				console.log(res)
				console.log(file)
				this.imageUrl = res.data
				// return
				// this.imageUrl = URL.createObjectURL(file.raw);
			},
			getUserInfo(uid) {
				this.$loading();
				var param = {
					uid: uid
				};
				this.$api.getUserInfo().then((res) => {
					this.imageUrl = res.data.user.image;
				});
				setTimeout(() => {
					this.$loading().close();
				}, 500);
			},
			changepic(e) {
				var that = this;
				var file = e.target.files[0];
				let size = Math.floor(file.size / 1024);
				if (size > 500) {
					this.$message({
						message: "请选择500k以内的图片",
						type: "info",
						showClose: true,
					});
					return;
				}
				var fr = new FileReader();
				fr.readAsDataURL(file);
				fr.onload = function(e) {
					that.imageUrl = e.target.result;
				};
			},
			// sureUpload() {
			// 	var param = {
			// 		uid: this.user_id,
			// 		file: this.imageUrl
			// 	};
			// 	this.$post("setImage", param).then((res) => {
			// 		// //console.log(res);
			// 		this.$router.go(0);
			// 		this.getUserInfo(this.user_id);
			// 		localStorage.setItem("user_image", this.imageUrl);
			// 	});
			// },
		},
		created() {
			this.getUserInfo(this.user_id);
			if (localStorage.getItem('UserToken')) {
				this.importHeaders = {
					'verify-token': localStorage.getItem('UserToken')
				}
			}
		},
	};
</script>

<style>
	.photo {
		padding: 0 40px;
	}

	/*修改头像*/
	.photo dt {
		font-size: 16px;
		color: #333;
		margin: 20px auto auto auto;
	}

	.photo dd {
		color: #999;
		margin: 10px 0;
	}

	.unload-photo {
		width: 180px;
		height: 180px;
		line-height: 180px;
		padding: 10px;
		text-align: center;
		box-shadow: 0 0 5px rgba(186, 186, 186, 0.8);
		border-radius: 10px;
		cursor: pointer;
		position: relative;
	}

	.unload-photo i {
		font-size: 24px;
		color: #999;
	}

	.unload-photo p {
		border: 1px dashed #dfdfdf;
		border-radius: 10px;
		overflow: hidden;
		width: 178px;
		height: 178px;
	}

	.unload-photo img {
		width: 100%;
		height: 100%;
	}

	.unload-photo input {
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		opacity: 0;
	}
</style>
